import * as React from "react";
import { forwardRef } from "react";
import { SimpleGrid as MantineSimpleGrid } from "@mantine/core";
const SimpleGrid = (props, ref) => /* @__PURE__ */ React.createElement(MantineSimpleGrid, { ref, ...props });
export default forwardRef(SimpleGrid);
